<template>
    <form-accordion
        name="listing-information"
        section="Listing Information / Showings"
        :url="url"
        method="PATCH"
        :closed="closed"
        :read_only="read_only"
    >
        <status
            :listing_detail="property.deal.listing_detail"
            :read_only="read_only"
        />

        <dates
            :listing_detail="property.deal.listing_detail"
            :read_only="read_only"
        />

        <price
            :listing_detail="property.deal.listing_detail"
            :read_only="read_only"
        />

        <price-reductions
            :listing_detail="property.deal.listing_detail"
            :read_only="read_only"
        />

        <listing-source
            :listing_detail="property.deal.listing_detail"
            :read_only="read_only"
        />

        <listing-showings
            :listing_detail="property.deal.listing_detail"
            :read_only="read_only"
        />
    </form-accordion>
</template>

<script>
import Status from './status.vue';
import Dates from './dates.vue';
import Price from './price.vue';
import PriceReductions from './price-reductions.vue';
import ListingSource from './listing-source.vue';
import ListingShowings from './listing-showings.vue';

export default {
    components: {
        Status,
        Dates,
        Price,
        PriceReductions,
        ListingSource,
        ListingShowings,
    },

    props: {
        url: {},
        closed: { default: true },
        property: { default: () => ({}) },
        read_only: { default: false },
    },
}
</script>


